// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"146f6dab","799":"146f6dab"}[chunkId] + ".chunk.css";
};